<template>
  <div class="console-page">
    <el-row type="flex" class="row-bg">
      <el-col :span="4" :xs="24">
        <el-form-item label="关键词" prop="keyword">
          <el-input v-model="paramsObj.keyword" placeholder="支持款式搜索" @keyup.enter="fetch"
            style="max-width: 120px;"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="5" :xs="24">
        <el-tree-select ref="companys" v-model="paramsObj.companyId" :data="companys" @change="fetch"
          check-strictly :render-after-expand="false" placeholder="请选择公司" style="width:200px" />
      </el-col>

      <el-col :span="3" :xs="24">
        <el-select v-model="paramsObj.storeCode" placeholder="请选择库房" size="default" @change="fetch" clearable
          style="max-width: 120px;">
          <el-option v-for="item in store" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" :xs="24">
        <el-select v-model="paramsObj.channel" placeholder="渠道" size="default" @change="fetch" clearable
          style="max-width: 120px;">
          <el-option v-for="item in channels" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="5" :xs="24">
        <el-date-picker v-model="valueTime" type="daterange" @calendar-change="fetch" @change="fetch"
          unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="YYYY-MM-DD"
          :shortcuts="$util.getShortCuts()" size="default" style="max-width: 210px;">
        </el-date-picker>
      </el-col>

      <el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
            <el-button style="margin: 0 10px" size="default" type="primary" @click="fetch"> 确认 </el-button>
            <el-button type="info" @click="consoleTableExport">导出明细</el-button>
      </el-col>
    </el-row>

    <el-row :gutter="12" class="panel-group">
      <!-- 销售件数 -->
      <el-tooltip class="box-item" effect="dark" content="时间周期内的销售总数" placement="top-start">
        <el-col :xs="24" :sm="12" :lg="3" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-people">
              <el-icon><Monitor /></el-icon>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">销售件数</div>
              <div class="card-panel-num">{{ toBigNumber(blocks.orderPayCount) }}</div>
            </div>
          </div>
        </el-col>
      </el-tooltip>

      <!-- 销售总额 -->
      <el-tooltip class="box-item" effect="dark" content="时间周期内的销售总额" placement="top-start">
        <el-col :xs="24" :sm="12" :lg="3" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-message">
              <el-icon><Stopwatch /></el-icon>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">销售总额(￥)</div>
              <div class="card-panel-num">{{ toBigNumber(blocks.orderPayTotal) }}</div>
            </div>
          </div>
        </el-col>
      </el-tooltip>

      <!-- 销售对应成本 -->
      <el-tooltip class="box-item" effect="dark" content="时间周期内的销售出库货品对应的货品成品" placement="top-start">
        <el-col :xs="24" :sm="12" :lg="3" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-shopping">
              <el-icon><Box /></el-icon>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">销售对应成本</div>
              <div class="card-panel-num">{{ toBigNumber(blocks.orderProductTotal) }}</div>
            </div>
          </div>
        </el-col>
      </el-tooltip>

      <!-- 采购总成本 -->
      <el-tooltip class="box-item" effect="dark" :content="'周期内的采购成本=采购数*(采购价+品牌使用费)'" placement="top-start">
        <el-col :xs="24" :sm="12" :lg="3" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-money">
              <el-icon><Files /></el-icon>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">采购总成本</div>
              <div class="card-panel-num">{{ toBigNumber(blocks.purchasePriceTotal) }}</div>
            </div>
          </div>
        </el-col>
      </el-tooltip>

      <!-- 动销率 -->
      <el-tooltip class="box-item" effect="dark"
        :content="'SKU动销率=(动销品数' + (blocks.changeCount || '0') + '/总品数' + (blocks.totalCount || '0') + ')*100%  （因算法调整2023年10月以后数据准确）'"
        placement="top-start">
        <el-col :xs="24" :sm="12" :lg="3" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-shopping">
              <el-icon><Postcard /></el-icon>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">动销率</div>
              <div class="card-panel-num">{{ (blocks.changeRate || '0') + '%' }}</div>
            </div>
          </div>
        </el-col>
      </el-tooltip>

      <!-- 在库总值 -->
      <el-tooltip class="box-item" effect="dark" :content="'在库价值=在库数*(采购价+品牌使用费)'" placement="top-start">
        <el-col :xs="24" :sm="12" :lg="3" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-money">
              <el-icon><Sell /></el-icon>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">在库总值(￥)</div>
              <div class="card-panel-num">{{ toBigNumber(blocks.sumProductPrice) }}</div>
            </div>
          </div>
        </el-col>
      </el-tooltip>

      <!-- 数量周转率 -->
      <el-tooltip class="box-item" effect="dark"
        :content="'销售对应货品采购成本:' + toBigNumber(blocks.orderPurchaseTotal) + '，' + '周期天数:' + blocks.rateDays + '，' + '库存日均总值:' + toBigNumber(blocks.avgPurchasePrice) + '，' + '采购周转率=(销售对应的货品总数(总金额)/库存日均总值)*100% （因算法调整2023年10月以后数据准确）'"
        placement="top-start">
        <el-col :xs="24" :sm="12" :lg="3" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-shopping">
              <el-icon><Sort /></el-icon>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">数量周转率</div>
              <div class="card-panel-num">{{ toBigNumber(blocks.rateNumberOfInventor * 100) }} %</div>
            </div>
          </div>
        </el-col>
      </el-tooltip>

      <!-- 金额周转率 -->
      <el-tooltip class="box-item" effect="dark"
        :content="'销售对应货品采购成本:' + toBigNumber(blocks.orderPurchaseTotal) + '，' + '周期天数:' + blocks.rateDays + '，' + '库存日均总值:' + toBigNumber(blocks.avgPurchasePrice) + '，' + '周转率=(销售对应的货品总数(总金额)/库存日均总值)*100% （因算法调整2023年10月以后数据准确）'"
        placement="top-start">
        <el-col :xs="24" :sm="12" :lg="3" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-shopping">
              <el-icon><DataAnalysis /></el-icon>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">金额周转率</div>
              <div class="card-panel-num">{{ toBigNumber(blocks.ratePriceOfInventor * 100) }} %</div>
            </div>
          </div>
        </el-col>
      </el-tooltip>
      <!-- blocks panels omitted for brevity, kept as in original -->
    </el-row>

    <el-card class="box-card">
      <el-table :data="tableData" :highlight-current-row="true"
        :default-sort="{ prop: 'saleStockNumber', order: 'descending' }" stripe border height="550"
        style="width: 100%" size="small">
        <el-table-column align="center" label="序号" type="index" width="50"></el-table-column>
        <el-table-column prop="detailCode" width="130" align="center" sortable label="系统款号">
          <template #default="dataObj">
            <el-button link style="font-size:0.8em;" @click="setSkuCode(dataObj.row)">{{ dataObj.row.detailCode
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="serialCode" align="center" sortable label="自定款号" width="110">
          <template #default="dataObj">{{ dataObj.row.serialCode }}</template>
        </el-table-column>
        <el-table-column prop="detailName" align="center" show-overflow-tooltip sortable label="名称">
          <template #default="dataObj">{{ dataObj.row.detailName }}</template>
        </el-table-column>

        <el-table-column prop="detailCode" align="center" label="图片" width="60">
          <template #default="dataObj">
            <el-image style="height: 32px; width: 32px" lazy
              :src="apiUrl + 'static/code/' + dataObj.row.detailCode + '?t=0'"
              :preview-src-list="[apiUrl + 'static/code/' + dataObj.row.detailCode + '?t=1']">
              <template #error>
                <img style="width: 100%" src="~@/assets/imgunfine.jpg" alt="" />
              </template>
            </el-image>
          </template>
        </el-table-column>

        <el-table-column prop="sumStockRemain" align="center" sortable width="90">
          <template #header>库存数</template>
          <template #default="dataObj">{{ toBigNumber(dataObj.row.sumStockRemain) }}</template>
        </el-table-column>

        <el-table-column prop="sumStockPurchasePrice" align="center" sortable label="库存额" width="90">
          <template #default="dataObj">{{ toBigNumber(dataObj.row.sumStockPurchasePrice) }}</template>
        </el-table-column>

        <el-table-column prop="minStockDate" align="center" sortable label="最早入库" width="90">
        </el-table-column>
        <el-table-column prop="maxStockDate" align="center" sortable label="最晚入库" width="90">
        </el-table-column>

        <el-table-column prop="avgStockPurchasePrice" align="center" sortable label="采购均价" width="90">
          <template #default="dataObj">{{ toBigNumber(dataObj.row.avgStockPurchasePrice) }}</template>
        </el-table-column>

        <el-table-column align="center" label="日均库存" width="80">
          <template #default="dataObj">
            {{ toBigNumber(dataObj.row.avgHisStockRemain)
            }}</template>
        </el-table-column>

        <!-- <el-table-column prop="AvgHisStockRemain" align="center" label="平均数" width="70">
          <template #default="dataObj">{{ toBigNumber(dataObj.row.startStockNumber / 2 + dataObj.row.endStockNumber
            / 2)
          }}</template>
        </el-table-column> -->

        <el-table-column prop="inStockNumber" align="center" sortable label="采购数" width="90">
          <template #default="dataObj">{{ toBigNumber(dataObj.row.inStockNumber) }}</template>
        </el-table-column>

        <el-table-column prop="sumInPurchasePrice" align="center" sortable width="90">
          <template #header><span title="周期内的整体采购额">采购额</span></template>
          <template #default="dataObj">{{ toBigNumber(dataObj.row.sumInPurchasePrice) }}</template>
        </el-table-column>

        <el-table-column prop="saleStockNumber" align="center" sortable label="销售数" width="90">
          <template #default="dataObj">{{ toBigNumber(dataObj.row.saleStockNumber * -1.0) }}</template>
        </el-table-column>

        <el-table-column prop="sumSellPrice" align="center" sortable width="90">
          <template #header><span title="销售额">销售额</span></template>
          <template #default="dataObj">
            <el-tooltip class="box-item" :content="'销售额'" placement="top-start" effect="dark">
              <div>
                {{ toBigNumber(dataObj.row.sumSellPrice) }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="sumSellPurchasePrice" align="center" width="90">
          <template #header><span title="销售额对应的采购额">销售采购额</span></template>
          <template #default="dataObj">
            <el-tooltip class="box-item" :content="'销售货品对应的采购额'" placement="top-start" effect="dark">
              <div>
                {{ toBigNumber(dataObj.row.sumSellPurchasePrice) }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column prop="stockNumberTurnoverRate" align="center" label="周转率" width="90" sortable>
          <template #default="dataObj">
            <el-tooltip class="box-item" :content="'销售对应货品成本:' + toBigNumber(dataObj.row.sumSellPurchasePrice) + '，'
              + '日均库存金额:' + toBigNumber(dataObj.row.daysAvgPurchasePrice) + '，'
              + '周转率=(销售对应货品成本/日均库存金额)*100%'" placement="top-start" effect="dark">
              {{ (dataObj.row.stockPurchaseTurnoverRate || 0).toFixed(2) }}%
              <!-- <div v-if="dataObj.row.avgHisStockRemain > 0 && Math.abs(dataObj.row.saleStockNumber) > 0">
                {{ toPercent(Math.abs(dataObj.row.saleStockNumber) / dataObj.row.avgHisStockRemain * 100) }}
              </div>
              <div v-else>
                -
              </div> -->
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>
    </el-card>
  </div>
</template>

<script>
import { consoleBlocks, consoleTable, consoleExport } from "@/api/console";
export default {
  name: 'DetailData',
  data() {
    return {
      apiUrl: process.env.VUE_APP_BASEURL,
      valueTime: [],
      paramsObj: {
        keyword: '',
        companyId: '',
        storeCode: '',
        channel: '',
        brand: '',
        startDate: '',
        endDate: ''
      },
      blocks: {},
      tableData: [],
      companys: [],
      store: [],
      channels: []
    }
  },
  methods: {
    getDefaultCompanyId() {
      const fromStore = (this.$store.getters.getUserInfo || {}).companyID;
      if (fromStore) return fromStore;
      try {
        const raw = sessionStorage.getItem('userInfo');
        const parsed = raw ? JSON.parse(raw) : {};
        return parsed.companyID || '';
      } catch (e) {
        return '';
      }
    },
    fetch() {
      if (!this.paramsObj.companyId) this.paramsObj.companyId = this.getDefaultCompanyId();
      if (!this.paramsObj.companyId) {
        this.$message.warning('请选择公司');
        return;
      }
      // allow fetch when paramsObj already has dates (mounted init), or when user selected valueTime
      if ((!this.valueTime || this.valueTime.length != 2) && (!this.paramsObj.startDate || !this.paramsObj.endDate)) {
        this.$message.warning('请选择时间范围');
        return;
      }
      if (this.valueTime && this.valueTime.length === 2) {
        this.paramsObj.startDate = this.formatTime(this.valueTime[0]);
        this.paramsObj.endDate = this.formatTime(this.valueTime[1]) + ' 23:59:59';
      }

      consoleBlocks(this.paramsObj).then((res) => {
        this.blocks = { ...res.data };
      });

      consoleTable(this.paramsObj).then((res) => {
        this.tableData = Object.values({ ...res.data });
      });
    },
    consoleTableExport() {
      consoleExport(this.paramsObj).then((res) => {
        this.$notify({ title: "导出成功", message: res.content, type: "success", duration: 10000 });
        window.location.href = process.env.VUE_APP_BASEURL + res.data;
      });
    },
    consoleBlockEvent(params) {
      consoleBlocks(params).then((res) => {
        this.blocks = { ...res.data };
      });
    },
    consoleTableEvent(params) {
      consoleTable(params).then((res) => {
        this.tableData = Object.values({ ...res.data });
      });
    },
    //百分位单位换算
    toPercent(val) {
      if (val == null) { return 0 + "%"; }
      else if (Math.round(val) === val && val / 10000 < 1) { return val + "%"; }
      else { return val.toFixed(2) + "%"; }
    },
    formatTime(val) { return val.getFullYear() + "-" + (val.getMonth() + 1) + "-" + val.getDate(); },
    toBigNumber(val) {
      if (val == null) { return '-'; }
      else if (Math.round(val) === val && val / 10000 < 1) { return val; }
      else { return this.toNumberFixed(val.toFixed(2)); }
    },
    toNumberFixed(value) {
      const newValue = ['', '', '']
      let fr = 1000
      let num = 3
      let text1 = ''
      let fm = 1
      while (value / fr >= 1) {
        fr *= 10
        num += 1
      }
      if (num <= 4) { newValue[0] = value }
      else if (num <= 8) {
        text1 = parseInt(num - 4) / 3 > 1 ? '千万' : '万'
        fm = text1 === '万' ? 10000 : 10000000
        if (value % fm === 0) { newValue[0] = parseInt(value / fm) + '' }
        else { newValue[0] = parseFloat(value / fm).toFixed(2) + '' }
        newValue[1] = text1
      } else if (num <= 16) {
        text1 = (num - 8) / 3 > 1 ? '千亿' : '亿'
        text1 = (num - 8) / 4 > 1 ? '万亿' : text1
        text1 = (num - 8) / 7 > 1 ? '千万亿' : text1
        fm = 1
        if (text1 === '亿') { fm = 100000000 }
        else if (text1 === '千亿') { fm = 100000000000 }
        else if (text1 === '万亿') { fm = 1000000000000 }
        else if (text1 === '千万亿') { fm = 1000000000000000 }
        if (value % fm === 0) { newValue[0] = parseInt(value / fm) + '' }
        else { newValue[0] = parseFloat(value / fm).toFixed(2) + '' }
        newValue[1] = text1
      }
      if (value < 1000) { newValue[0] = value + ''; newValue[1] = '' }
      return newValue.join('')
    },
    // emit SKU select to parent
    setSku(row) { this.$emit('set-sku', row); },
    setSkuCode(row) { this.$emit('set-sku', row); }
  },
  mounted() {
    this.paramsObj.companyId = this.getDefaultCompanyId();
    this.$kaung.dictionary('stock', 'store').then(res => this.store = res);
    this.$kaung.dictionary('stock', 'channel').then(res => this.channels = res);
    this.$kaung.companys().then(res => this.companys = res);
    // initialize default date range (current month) via paramsObj and fetch overview data
    const range = this.$util.getCurrentDate('month');
    if (range && range.length === 2) {
      this.valueTime = range;
      this.paramsObj.startDate = this.formatTime(range[0]);
      this.paramsObj.endDate = this.formatTime(range[1]) + ' 23:59:59';
    }
  }
}
</script>

<style scoped>
.console-page { padding: 0; }
</style>

<style lang="less" scoped>
.console-page {
  .el-row {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .box-card {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  h4 {
    margin-top: 5px;

    .number {
      color: #409eff;
    }
  }

  .tableshow {
    img {
      transform: scale(1.3, 1.3);
    }
  }

  .showtext {
    line-height: 20px;
    margin-left: 10px;
  }

  .row-bg {
    .el-col {
      padding: 2px 0;
    }

    padding: 10px 10px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .el-date-editor {
    width: 100%;
    max-width: 280px;
  }

  .text-gray {
    font-family: "PingFang SC";
  }

  .el-table th>.cell {
    padding: 0;
    color: #000;
  }

  .el-table .caret-wrapper {
    width: 12px;
    left: -5px;
  }
}

.panel-group .card-panel:hover {
  background: #a9a9a9;
}

.panel-group .card-panel {
  height: 70px !important;
}

.panel-group .card-panel .card-panel-icon-wrapper {
  margin: 10px 0 0 10px !important;
}

.card-panel .card-panel-description {
  margin-top: 10px !important;
}

@media (max-width: 550px) {
  .card-panel-icon-wrapper {
    width: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
